/* eslint-disable no-unused-vars */
import React from 'react';

import { GoogleAnalyticsConstants, GoogleAnalyticsDisplayedEvent } from '@vvoyages/google-analytics';
import { Form, Formik } from 'formik';

import * as Yup from 'yup';

import Button from '@/components/Button';
import { WizardStep } from '@/components/Wizard';
import { appUiIds } from '@/constants/appUiIds';
import { isAgeValidForBooking } from '@/helpers/dateUtil';
import useAppUiData from '@/hooks/useAppUiData';

import styles from './ClaimBookingStep.module.scss';
import ClaimBookingDoBInput from './controls/ClaimBookingDoBInput';


type ClaimBookingDobUpdateProps = {
  tabId: string;
  onNext: Function;
  onCancel: () => void;
  data: Record<string, any>;
};

const ClaimBookingDobUpdate: React.FC<ClaimBookingDobUpdateProps> = ({ tabId, onNext, onCancel, data }) => {
  const appUiData = useAppUiData();
  const sailingStartDate = data?.reservationDetails?.fromDate;

  const DisplayingErrorMessagesSchema = Yup.object().shape({
    dob: Yup.string().test(
      'is-valid-age',
      'You must be 18 or older by the voyage start date to sail with us',
      (dob: string | undefined) => isAgeValidForBooking(dob, sailingStartDate),
    ),
  });

  const handleFormSubmit = async ({ dob }: { dob: string }) => {
    const updatedData = {
      ...data,
      selectedDOB: dob,
    };
    onNext(updatedData);
  };

  return (
    <WizardStep tabId={tabId}>
      <GoogleAnalyticsDisplayedEvent eventAction={GoogleAnalyticsConstants.EVENT_ACTION.DISPLAYED} />
      <div className={styles.dobUpdateFormContent}>
      <h2 className={styles.updateDobTitle}>{appUiData[appUiIds.claimBooking.missingDobTitle]}</h2>
      <p className={styles.updateDobSubtext}>{appUiData[appUiIds.claimBooking.missingDobSubtext]}</p>
      <Formik
        initialValues={{
          dob: '',
        }}
        validationSchema={DisplayingErrorMessagesSchema}
        validateOnChange
        validateOnBlur
        onSubmit={handleFormSubmit}
      >
        {({ values, isValid }) => {
          const isFormFilled = Object.values(values).every((field) => Boolean(field)) && isValid;
          return (
            <Form className={styles.manualForm}>
              <div className={styles.claimForm}>
                <ClaimBookingDoBInput name="dob" label="Date of Birth*" required disabled={false} />
                <Button type="submit" variant="primary" disabled={!isFormFilled} className={styles.dobClaimSubmit}>
                  {appUiData[appUiIds.commonLabels.next]}
                </Button>
                <Button onClick={onCancel} className={styles.cancelLink}>
                  {appUiData[appUiIds.commonLabels.cancel]}
                </Button>
              </div>
            </Form>
          );
        }}
      </Formik>
      </div>
    </WizardStep>
  );
};

export default ClaimBookingDobUpdate;
